import React from "react";

export const SoftUpArrowIconCap = (props: React.HTMLAttributes<SVGElement>) => {
  return (
    <svg width="9" height="9" viewBox="0 0 9 6" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props} >
      <path d="m4.499308,0.51796875 c-0.142868,0 -0.284967,0.059816 -0.384961,0.1810547 L0.84481497,4.6646484 c-0.268978,0.32612 -0.03777,0.8173828 0.38496103,0.8173828 H1.999698 L4.114347,2.9173828 c0.199989,-0.242477 0.571689,-0.242477 0.771679,0 l2.114649,2.5646484 h0.768164 c0.42273,0 0.65569,-0.4912628 0.386719,-0.8173828 L4.886026,0.69902345 C4.786031,0.57778495 4.642175,0.51796875 4.499308,0.51796875 Z" />
    </svg>
  );
};
